import React from 'react';
import { Link } from 'gatsby';

import Layout from '../components/layout';
import Image from '../components/image';
import SEO from '../components/seo';

const IndexPage = () => (
  <Layout>
    <SEO title="Obstetrics and Gynecology" keywords={[`Vancouver`, `Obstetrics`, `Gynecology`]} />


    <h2>Specialists in Obstetrics and Gynecology</h2>

	<div style= {{ float: `left`, marginRight: `1.45rem`, marginBottom: `1.45rem` }}>
		<h3>The Doctors</h3>
		<p>
			Dr. Jacquelynn Schouls <br/>
			Dr. Michele Lipp <br/>
			Dr. Carolyn Donnelly<br/>
			Dr. Emelie Hoyer<br/>
		</p>
        </div>

	<div style= {{ maxWidth: `700px` }}>
      		<Image />
	</div>
	
	<div style= {{ clear: `right`, marginBottom: `1.45rem` }} />

    <p>We are currently accepting new patients.  All patients require a referral from their family physician. This can be faxed to our office.  We will then contact you with an appointment time.</p>


  </Layout>

);

export default IndexPage;
